import { ScrollProvider } from "./ScrollContext";
import { useScrollContext } from "./hooks";

export { useScrollContext, ScrollProvider };
